import dayjs from 'dayjs'
import 'dayjs/locale/da'

dayjs.locale('da')

const timeFormat = (time: Date) => {
    return dayjs(time).format('HH:mm')
}

const dateFormat = (date: Date) => {
    return dayjs(date).format('DD. MMMM - YYYY')
}

export function dateTimeFormat(date: Date) {
    return `${timeFormat(date)} | ${dateFormat(date)}`
}
export function formatStartAndEndDate(startDate: Date | null, endDate: Date | null) {
    if (!startDate || !endDate) {
        return '';
    }

    if (startDate.getDay() === endDate.getDay() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()) {
        return `${timeFormat(startDate)} - ${timeFormat(endDate)} | ${dateFormat(startDate)}`;
    } else {
        return `${dateFormat(startDate)}, ${timeFormat(startDate)} | ${dateFormat(endDate)}, ${timeFormat(endDate)}`;
    }
}

export { dateFormat, timeFormat }
